import { render, staticRenderFns } from "./freeIndex.vue?vue&type=template&id=c3425a9e&scoped=true"
import script from "./freeIndex.vue?vue&type=script&lang=js"
export * from "./freeIndex.vue?vue&type=script&lang=js"
import style0 from "./freeIndex.vue?vue&type=style&index=0&id=c3425a9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3425a9e",
  null
  
)

export default component.exports